import { Bar, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

export const InsightChart = ({ chart }) => {
  const data = chart.labels.map((label, i) => ({ name: label, value: chart.values[i] }));
  return (
    <div
      className="bg-white border border-[#DCE3DF] rounded-[10px] shadow-[0_4px_20px_rgba(20,30,26,0.06)] p-6"
      data-testid="insight-chart"
    >
      <p className="text-xs font-mono uppercase tracking-[0.1em] text-[#5A6B63] mb-4">{chart.title}</p>
      <ResponsiveContainer width="100%" height={260}>
        <BarChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 8 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#DCE3DF" vertical={false} />
          <XAxis dataKey="name" tick={{ fontSize: 12, fill: "#5A6B63" }} />
          <YAxis tick={{ fontSize: 12, fill: "#5A6B63" }} />
          <Tooltip contentStyle={{ borderRadius: 8, borderColor: "#DCE3DF", fontFamily: "Inter" }} />
          <Bar dataKey="value" fill="#0E6E52" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
